<template>
    <v-dialog
        v-model="dialog"
        @click:outside="closeDialog"
        :max-width="introDialog ? '500px' : '1000px'"
        content-class="rpd-dialog"
        overlay-opacity="0.8"
        :elevation="0"
    >   
        <template v-if="introDialog">
            <v-card max-width="500px" style="margin: auto; overflow: hidden; width: fit-content;">
                <v-card-title class="text-primary-700">Welcome to the {{ routeHasVideo ? pageNames.find(page => page.route == currentRoute).name : 'page' }}! </v-card-title>
                <v-card-text class="pb-0">
                    <!-- dont show again checkbox -->
                     <h3>Would you like to watch a video on how to use this page?</h3>
                    <v-checkbox 
                        class="py-2" 
                        v-model="dontShowAgain" 
                        color="primary"
                    >
                        <template v-slot:label>
                            <span class="">Don't show again</span>
                        </template>
                    </v-checkbox>
                </v-card-text>
                <v-card-actions class="rpd-intro-dialog-actions">
                    <v-btn color="primary" @click="introDialog = false">Yes Please</v-btn>
                    <v-btn  @click="closeDialog">No Thank You</v-btn>
                </v-card-actions>
            </v-card>
        </template>
        <template v-else>
            <!-- <v-checkbox 
                class="rpd-video-title rpd-checkbox py-2" 
                v-model="dontShowAgain" 
                color="white"
            >
                <template v-slot:label>
                    <span class="rpd-checkbox-label">Don't show again</span>
                </template>
            </v-checkbox> -->
            <div class="rpd-video-background">
                <!-- <div class="rpd-video-loader">
                    <v-icon>
                        mdi-loading
                    </v-icon>
                </div> -->

                <div class="rpd-video-container">
                    <div class="rpd-video" style="width:100%">
                        <iframe :src="'https://www.loom.com/embed/' + videos[index-1].video_id + '?hideEmbedTopBar=true&hide_share=true&autoplay=0&hide_owner=true'" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen hide_owner="true" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; border-radius: 5px;"></iframe>
                    </div>
                </div>
                <!-- <h2 class="rpd-video-title">Video Title</h2> -->
                <!-- dont show again checkbox -->
                
            </div>
            <div class="rpd-video-tools mt-4">
                <!-- left arrow icon -->
                    <div v-if="videos.length > 1" style="display: flex; align-items: center;">
                        <v-btn 
                            class="rpd-video-icon" 
                            icon
                            @click="index = index - 1 < 1 ? videos.length : index - 1">
                            <v-icon>
                                mdi-arrow-left
                            </v-icon>
                        </v-btn>

                    <!-- index / total -->
                    <span class="rpd-video-tool-text">{{ index }} / {{ videos.length }}</span>

                    <!-- right arrow icon -->
                    <v-btn 
                        class="rpd-video-icon" 
                        icon
                        @click="index = index + 1 > videos.length ? 1 : index + 1">
                        <v-icon>
                            mdi-arrow-right
                        </v-icon>
                    </v-btn>
                </div>
                <span class="rpd-video-tool-title">{{  videos[index-1].video_name  }}</span>
            </div>
        </template>
    </v-dialog>
</template>
<script>
    export default {
        data() {
            return {
                dialog: false,

                introDialog: true,

                showDelay: false,
                dontShowAgain: false,
                videos: [{
                    video_id: '',
                    video_name: '',
                }],

                pageNames: [
                    {
                        name: 'Home Page',
                        route: '/'
                    },
                    {
                        name: 'Help Page',
                        route: '/help'
                    },
                    {
                        name: 'Companies Page',
                        route: '/companies'
                    }
                    
                ],
                
                index: 1,
            }
        },
        methods: {
            closeDialog() {
                if(this.dontShowAgain){
                    console.log('dont show again');
                    this.hideVideo();
                }
                console.log('close dialog before session hide video');
                this.sessionHideVideo();
                console.log('close dialog after session hide video');
                this.dialog = false;
                setTimeout(() => {
                    this.showDelay = false;
                }, 500);
            },
            openDialog(videos) {
                this.clearData();
                this.videos = videos;
                this.dialog = true;
                this.showDelay = true;
            },
            hideVideo() {
                // for each video, hide the id
                this.videos.forEach(video => {
                    this.$http.put(`/settings/hide-video`, {
                        video_id: video.video_id
                    })
                });
            },
            sessionHideVideo(){
                let arr = [];
                this.videos.forEach(video => {
                    arr.push(video.video_id)
                });
                
                let hiddenvids = JSON.parse(sessionStorage.getItem('hiddenVideos'))
                console.log(hiddenvids);
                // merge the two arrays, ensuring no duplicates
                if(hiddenvids){
                    arr = [...new Set([...arr, ...hiddenvids])];
                }

                sessionStorage.setItem('hiddenVideos', JSON.stringify(arr));
                console.log('session hide video');
            },
            clearData() {
                this.videos = [];
                this.index = 1;
                this.introDialog = true;
            }
        },
        computed: {
            // compute current route
            currentRoute() {
                return this.$route.path;
            },
            routeHasVideo() {
                // return true if any of the videos have the current route
                return this.videos.some(video => video.route == this.currentRoute);
            }
        },
        watch: {
            // watch for route change
            currentRoute() {
                
            }
        }
    }
</script>

<style>
    .rpd-dialog{
        overflow: visible;
        box-shadow: 0px 0px 0px rgb(0, 0, 0);
    }

    .rpd-video-container {
        /* max-width: 600px;
        height: fit-content; */
        width: 100%;
    }

    .rpd-video-tools {
        
        color: #eeeeee;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .rpd-video-icon {
        font-size: 30px;
        margin: 0 10px;
        color: #eeeeee !important;
        width: 30px;
        height: 30px;
    }

    .rpd-video-background {
        overflow: visible;
        display: flex;
        justify-content: center;
        flex-direction: column;
        width: 100%;
        align-items: center;
        /* drop shadow */
        box-shadow: 0px 0px 50px rgb(0, 0, 0, 0.5);
        border-radius: 5px;
        background-color: #000000;
        /* padding: 10px; */
    }

    .rpd-video-tool-text{
        font-size: 20px;
        color: #eeeeee;
    }

    .rpd-video-tool-title{
        font-size: 28px;
        color: #eeeeee;
        margin-top: 10px;
    }

    .rpd-video-loader {
        position: absolute;
        top: 50%;
        left: 50%;
        font-size: 50px;
        color: rgb(188, 188, 188) !important;
        text-align: center;
        
    }

    .rpd-video-title {
        text-align: center;
        /* dark gray */
        color: #eeeeee;
        font-size: 20px;
        margin-top: 16px;
        /* background-color: #1c1c1ca4; */
        border-radius: 5px;
        padding: 4px 14px;

        /* drop shadow */
        text-shadow: 0px 0px 25px rgb(0, 0, 0);
    }

    .rpd-checkbox .v-messages{
        display: none !important;
    }

    .rpd-checkbox .v-input__slot{
        margin: 0;
    }

    .v-input--selection-controls__input:hover .v-input--selection-controls__ripple:before{
        transform: scale(1);
        -webkit-transform: scale(1);
    }

    .v-ripple__container{
        transform: scale(1);
        -webkit-transform: scale(1);
    }

    .rpd-checkbox .v-icon{
        color: white;
    }

    .rpd-checkbox-label{
        color: #eeeeee;
        font-weight: 500;
        font-size: 18px;
    }

    .rpd-intro-dialog-actions{
        padding: 0 !important;

    }
    .rpd-intro-dialog-actions .v-btn{
        width: 50%;
        margin: 0 !important;
        padding: auto;
        border-radius: 0;
        height: 50px !important;
    }
    /* first child bottom left border radius, right child bottom right border radius */
    .rpd-intro-dialog-actions .v-btn:first-child{
        border-bottom-left-radius: 4px;
    }
    .rpd-intro-dialog-actions .v-btn:last-child{
        border-bottom-right-radius: 4px;
    }
</style>